// extracted by mini-css-extract-plugin
export default {"divider":"divider_divider__q0TIA","img":"divider_img__5v47d"};